<header class="header flex justify-end align-center">
  <div class="header__logo">
    <img src="assets/images/logo-dark.svg" alt="Noble quote" />
  </div>
  <div class="header__profile">
    <picture
      (click)="toggleMenu()"
      inClickOutside
      (clickOutside)="showMenu = false"
    >
      <img src="assets/images/avatar.png" alt="avatar" />
    </picture>
    <ul [ngClass]="showMenu ? 'active' : ''">
      <li
        [routerLink]="['/profile']"
        *ngIf="
          userRoles.EMPLOYEE === (profileService.profileDetails | async)?.role
        "
      >
        <img src="assets/images/avatar.svg" alt="Avatar" />
        Profile
      </li>
      <li (click)="logout()">
        <img src="assets/images/power.svg" alt="Logout" />
        Logout
      </li>
    </ul>
  </div>
  <a class="header__hamburger" (click)="showSideBar()">
    <span></span>
  </a>
</header>
